<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Edit'}} {{title}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>
  <div class="ttmodal__body">
    <div style="padding: 1%;">
      <div *ngIf="SelectedType==1">
        <mat-radio-group name="_SetupframeConfig" [(ngModel)]="_FrameConfig" (change)="FrameConfigChange($event)">
          <mat-radio-button [value]="2">{{'Straight'}}</mat-radio-button>
          <mat-radio-button [value]="1" style="margin-left: 15px;">{{'Toe out'}}</mat-radio-button>
        </mat-radio-group>
        <div style="padding-left: 2%; margin-top: 16px; font-size: 15px;">
          <strong>Important:</strong>
          <ol>
            <li>{{"If you are making this change because the data is simply incorrect, then proceed."}}</li>
            <li>{{"If a change is required because "}}<b>{{"the "}}</b> {{"Frame has been changed, please do "}}<b>{{"NOT"}}</b>{{" proceed. Go to the Actions screen and record the Frame replacement at the correct Date SMU and DOE."}}</li>
            <li>{{"Please note that the Equaliser Bar must be the same type as the Frame configuration."}}</li>
          </ol>
        </div>
        <button mat-raised-button (click)="onNoClick()">{{'Cancel'}}</button>
        <button mat-raised-button color="warn" [class.loading]="saving"
          (click)="SaveFramConfiguration()"><span class="material-icons button__icon">check</span>
          <span class="button__text">{{'Update'}}</span></button>
      </div>

      <div *ngIf="SelectedType==2">
        <mat-radio-group name="_SetupcannonType" [(ngModel)]="_CannonType" (change)="FrameCannonChange($event)">
          <mat-radio-button [value]="1">{{'Cast'}}</mat-radio-button>
          <mat-radio-button [value]="2">{{'Fabricated'}}</mat-radio-button>
        </mat-radio-group>
        <div style="padding-left: 2%; margin-top: 16px; font-size: 15px;">
          <strong>Important:</strong>
          <ol>
            <li>{{"If you are making this change because the data is simply incorrect, then proceed."}}</li>
            <li>{{"If a change is required because "}}<b>{{"the "}}</b> {{"Frame has been changed, please do "}}<b>{{"NOT"}}</b>{{" proceed. Go to the Actions screen and record the Frame replacement at the correct Date SMU and DOE."}}</li>
          </ol>
        </div>
        <button mat-raised-button (click)="onNoClick()">{{'Cancel'}}</button>
        <button mat-raised-button color="warn" [class.loading]="saving"
          (click)="SaveFramConfiguration()"><span class="material-icons button__icon">check</span>
          <span class="button__text">{{'Update'}}</span></button>
      </div>
    </div>
  </div>
</div>